import { createContext, useContext } from 'react'

import { ConnectionTarget } from './bpmn-graph.mapper'

import { Point } from '../../dictionary/geometry.types'

/**
 * Resolves the node (and the port on it) a live connection gesture would land
 * on. Provided by the canvas because the answer needs the BPMN data — the node
 * rects and the sequence policy — which React Flow's store does not carry.
 */
export type ConnectionTargetResolver = (
  pointer: Point,
  sourceRfId: string
) => ConnectionTarget | null

export const ConnectionTargetContext = createContext<ConnectionTargetResolver | null>(null)

export function useConnectionTargetResolver(): ConnectionTargetResolver {
  const resolve = useContext(ConnectionTargetContext)
  if (!resolve) {
    throw new Error('useConnectionTargetResolver must be used within a BpmnFlowCanvas')
  }

  return resolve
}
